export function runRequirement(inputs: Record<string, unknown> | undefined): string {
  const raw = inputs?.['user_task_description'];
  const text = typeof raw === 'string' ? raw.replace(/\s+/g, ' ').trim() : '';
  return text === '' ? 'Untitled run' : text;
}

export function formatTimestamp(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toISOString().replace('T', ' ').slice(0, 19);
}

export function formatTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toISOString().slice(11, 19);
}

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const diffMs = Date.now() - d.getTime();
  const diffMin = Math.floor(diffMs / 60_000);
  const diffHr = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHr / 24);
  if (diffMin < 1) return 'just now';
  if (diffHr < 1) return `${diffMin}m ago`;
  if (diffDay < 1) return d.toISOString().slice(11, 16);
  if (diffDay === 1) return 'yesterday';
  if (diffDay < 7) return `${diffDay}d ago`;
  return d.toISOString().replace('T', ' ').slice(0, 16);
}

export function formatDuration(
  startIso: string | null,
  endIso: string | null,
  frozenEndIso?: string | null
): string {
  if (!startIso) return '—';
  const start = new Date(startIso).getTime();
  const settledIso = endIso ?? frozenEndIso ?? null;
  const end = settledIso ? new Date(settledIso).getTime() : Date.now();
  const ms = Math.max(0, end - start);
  const sec = Math.floor(ms / 1000);
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  const suffix = settledIso ? '' : ' (live)';
  if (m > 0) return `${m}m ${s}s${suffix}`;
  return `${s}s${suffix}`;
}

export type DaysUntil = { kind: 'days'; days: number } | { kind: 'passed' } | { kind: 'unknown' };

export function daysUntil(iso: string | null | undefined, now: number = Date.now()): DaysUntil {
  if (!iso) return { kind: 'unknown' };
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return { kind: 'unknown' };
  const ms = then - now;
  if (ms <= 0) return { kind: 'passed' };
  return { kind: 'days', days: Math.ceil(ms / 86_400_000) };
}

export function formatAge(iso: string | null): string {
  if (!iso) return '—';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '—';
  const sec = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (sec < 60) return `${sec}s`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h`;
  const days = Math.floor(hr / 24);
  if (days < 30) return `${days}d`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo`;
  return `${Math.floor(months / 12)}y`;
}
